import FollowedLysts from "./followed-lysts";

export default FollowedLysts;
